// extracted by mini-css-extract-plugin
export default {"logo":"bmNl3RjlKYgPAYZllF4k"};